import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsScratchComponent } from './simple-icons-scratch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsScratchComponent ],
    exports:      [ SimpleIconsScratchComponent ],
    bootstrap:    []
})
export class SimpleIconsScratchModule {}
